import { render, staticRenderFns } from "./ScanCodeDetail.vue?vue&type=template&id=65a4f1b0&scoped=true&"
import script from "./ScanCodeDetail.vue?vue&type=script&lang=js&"
export * from "./ScanCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScanCodeDetail.vue?vue&type=style&index=0&id=65a4f1b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4f1b0",
  null
  
)

export default component.exports